module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": ("/static/images/logos/trm-" + (_vm.$root.marathon.id) + ".png"),
      "alt": "TRM Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "hamburger-menu",
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigation-area",
    class: {
      hamburgerOpen: _vm.hamburgerOpen
    }
  }, [_c('div', {
    staticClass: "social-media"
  }, [_c('ul', {
    staticClass: "social-channels"
  }, _vm._l((_vm.$root.social), function(social, index) {
    return _c('li', {
      key: ("social.item." + index),
      class: social.platform.toLowerCase()
    }, [_c('a', {
      attrs: {
        "href": social.link,
        "target": "_blank",
        "title": social.platform
      }
    }, [_c('span', {
      class: ("fa fa-" + (social.platform.toLowerCase()))
    })])])
  }), 0)]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      key: ("nav.item." + index),
      staticClass: "trm-nav-item",
      class: item.title.toLowerCase().replace(/ /g, "")
    }, [(item.isExternal !== true) ? _c('router-link', {
      attrs: {
        "to": {
          path: item.link
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d08d179","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Navbar.vue
// module id = 234
// module chunks = 1